module.exports = __webpack_public_path__ + "img/variable-2.6faf00c8.png";